import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';
import type { Recommendations } from '@/domains/productDiscovery/Recommendation/interfaces/productRecommendation';

import type {
  CategoriesRecommendationsState,
  CategoriesRecoPlaylist,
} from '../interfaces/msCatalogCategory';
import type {
  MsRecommendationProcessedResponse,
  ProcessedRecommendationItem,
} from '../interfaces/msRecommendation';

const complementaryCategories = ['CategoryCouples'];

export const selectCategoryRecommendationConfig = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): MsRecommendationProcessedResponse | undefined =>
  state.productDiscovery?.productRecommendation?.recommendationsConfig;

export const selectAllCategoryRecommendationsConfig = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): ProcessedRecommendationItem[] =>
  selectCategoryRecommendationConfig(state)?.filter((reco) =>
    complementaryCategories.includes(reco.engineName ?? ''),
  ) ?? [];

export const selectCategoryRecommendationsConfig = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
  engineName = 'CategoryCouples',
): ProcessedRecommendationItem | undefined =>
  selectCategoryRecommendationConfig(state)?.find(
    (reco) => reco.engineName === engineName,
  );

export const selectComplementaryCategoriesState = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): CategoriesRecommendationsState | undefined =>
  state.productDiscovery?.categoriesRecommendation;

export const selectComplementaryCategories = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
  engineName = 'CategoryCouples',
): CategoriesRecoPlaylist | undefined =>
  state.productDiscovery?.categoriesRecommendation?.recommendations?.find(
    (reco) => reco.engineName === engineName,
  );

export const selectTopSalesCategoriesRecommendations = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): Recommendations[] | undefined =>
  state.productDiscovery?.categoriesRecommendation
    ?.topSalesCategoriesRecommendations;
